export const version = process.env.REACT_APP_VERSION
export const wasmSize = Number(process.env.REACT_APP_WASM_SIZE)
